<template>
	<div class="sa-free-page">
		<div class="sa-free-page-body">
			<b-row>
				<b-col lg="3" xl="2">
					<div class="d-flex justify-content-between align-items-center mb-3">
						<h6 class="small text-muted font-weight-bold m-0 uppercase">Filtra Agende</h6>
						<b-button variant="link" size="sm" class="p-0 text-primary" @click="toggleTutte">
							{{ selezionateIds.length === agende.length ? "Deseleziona" : "Tutte" }}
						</b-button>
					</div>

					<div v-for="a in agende" :key="a.id" @click="toggleAgenda(a.id)" :class="['sa-agenda-selector-card', isSelezionata(a.id) ? 'is-selected' : '']">
						<div class="sa-agenda-card-info">
							<div class="sa-agenda-card-title">{{ a.titolo }}</div>
							<div class="sa-agenda-card-sub">{{ a.gruppo }}</div>
						</div>
						<div class="sa-agenda-check-icon">
							<b-icon v-if="isSelezionata(a.id)" icon="check" font-scale="1.2"></b-icon>
						</div>
					</div>
				</b-col>

				<b-col lg="9" xl="10">
					<div class="d-flex justify-content-between align-items-center mb-4">
						<div class="d-flex align-items-center">
							<b-button variant="white" pill @click="cambiaData(-1)" class="border shadow-sm mr-2"><b-icon icon="chevron-left"></b-icon></b-button>
							<h4 class="mb-0 font-weight-bold text-capitalize mx-3">{{ labelDataCorrente }}</h4>
							<b-button variant="white" pill @click="cambiaData(1)" class="border shadow-sm"><b-icon icon="chevron-right"></b-icon></b-button>
						</div>
						<b-button variant="primary" pill class="font-weight-bold px-4">+ Nuova Prenotazione</b-button>
					</div>

					<div v-if="selezionateIds.length === 0" class="text-center p-5 bg-white rounded-lg border border-dashed">
						<b-icon icon="calendar-plus" font-scale="3" class="text-light mb-3"></b-icon>
						<h5 class="text-muted">Seleziona almeno un'agenda dal menu laterale</h5>
					</div>

					<div v-else class="sa-agenda-wrapper shadow-sm">
						<div class="d-flex bg-white">
							<div class="sa-agenda-header-cell" style="width: 80px">Ora</div>
							<div v-for="agenda in agendeVisibili" :key="agenda.id" class="flex-grow-1 sa-agenda-header-cell border-left">
								{{ agenda.titolo }}
								<div class="text-primary mt-1" style="font-size: 0.6rem">{{ agenda.gruppo }}</div>
							</div>
						</div>

						<div v-for="h in timeline" :key="h" class="d-flex border-bottom bg-white">
							<div class="sa-agenda-time-col">{{ h }}</div>

							<div v-for="agenda in agendeVisibili" :key="agenda.id" class="flex-grow-1 border-left d-flex flex-column" style="flex-basis: 0; min-width: 150px">
								<div v-if="getApp(agenda.id, h)" :class="['sa-agenda-item', getApp(agenda.id, h).tipo === 'VISITA' ? 'color-visita' : 'color-informatore']">
									<div class="font-weight-bold truncate">{{ getApp(agenda.id, h).paziente }}</div>
									<div class="small opacity-75 truncate">{{ getApp(agenda.id, h).prestazione }}</div>
								</div>
								<a v-else href="#" class="sa-agenda-empty-slot" @click.prevent="apriPrenotazione(agenda, h)"> <b-icon icon="plus" class="mr-1"></b-icon> Libero </a>
							</div>
						</div>
					</div>
				</b-col>
			</b-row>
		</div>
		<div class="sa-free-page-footer">Footer</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			vista: "panoramica",
			selezionateIds: ["1", "2"], // Di default selezioniamo le prime due
			dataRiferimento: new Date(),
			agendaSelezionata: null,
			form: { cognome: "", ora: "", tipo: "VISITA" },
			agende: [
				{ id: "1", titolo: "DOT. LUCA DE LUCIA", durata_appuntamento: 20, gruppo: "Cardiologia" },
				{ id: "2", titolo: "DR.SSA MARIA ROSSI", durata_appuntamento: 30, gruppo: "Pediatria" },
				{ id: "3", titolo: "AMBULATORIO 3", durata_appuntamento: 15, gruppo: "Chirurgia" },
			],
			appuntamenti: [{ id_agenda: "1", cognome: "TAMMARO", tipo: "VISITA", descrizione_prestazione: "Massoterapia", data_ora_inizio: new Date() }],
		};
	},
	computed: {
		labelDataCorrente() {
			return this.dataRiferimento; //.format("dddd D MMMM YYYY");
		},
		agendeVisibili() {
			return this.agende.filter((a) => this.selezionateIds.includes(a.id));
		},
		timeline() {
			let t = [];
			for (let i = 9; i <= 14; i++) {
				t.push(i.toString().padStart(2, "0") + ":00");
				t.push(i.toString().padStart(2, "0") + ":30");
			}
			return t;
		},
	},
	methods: {
		isSelezionata(id) {
			return this.selezionateIds.includes(id);
		},
		toggleAgenda(id) {
			const index = this.selezionateIds.indexOf(id);
			if (index > -1) this.selezionateIds.splice(index, 1);
			else this.selezionateIds.push(id);
		},
		toggleTutte() {
			if (this.selezionateIds.length === this.agende.length) this.selezionateIds = [];
			else this.selezionateIds = this.agende.map((a) => a.id);
		},
		cambiaData(n) {
			console.log(n);
			this.dataRiferimento = null; //dayjs(this.dataRiferimento).add(n, "day");
		},
		getApp(agendaId, ora) {
			return this.appuntamenti.find((a) => a.id_agenda === agendaId && a.ora === ora);
		},
		apriPrenotazione(agenda, ora) {
			alert(`Nuovo appuntamento per ${agenda.titolo} alle ore ${ora}`);
		},
	},
};
</script>

<style></style>
